import './CdiRelaciones.scss'
import React, { Component } from 'react'
import {withRouter} from '../../helpers/withRouter'
import { withTranslation } from 'react-i18next'
import { Page, PageBottomBar, PageContent, PageHeader, PageTopBar } from '../../layouts/Private/components'
import { Content, Sidebar, Wrapper } from './layout'
import { DashboardPage, SolicitudesPage, FormManagerPage, ReportingPage } from './components'

class CdiRelaciones extends Component {
	state = {
		activeTab: 'tab-solicitudes',
		breadcrumbs: this.getBreadcrumbs(),
		categories: [],
		options: {}
	}

	getBreadcrumbs() {
		const { t } = this.props

		const breadcrumbs = [
			{ title: t('messages.aml.title.CDI'), icon: 'form', link: '/cdi-relaciones' },
		]

		return breadcrumbs
	}

	handleTabChange(activeTab, options) {
		this.setState({ activeTab, options })
	}

	handleTabChangeDashboard(activeTab, options) {
		window.scrollTo(0, 0)
		if(activeTab === 'records') {
			const { history } = this.props
            const params = btoa(JSON.stringify(options))
			history.push("/registro/" + params)
		}else {
			this.handleTabChange(activeTab, options)
		}
	}

	render() {
		const { activeTab, breadcrumbs, categories, options } = this.state
		const { currentUser, t } = this.props

		return (
			<div className="cdi-relaciones">
				<PageTopBar breadcrumbs={ breadcrumbs } />
				<Page>
					<PageHeader
						title={t('messages.aml.title.CDI')}
						icon="search"
						description="Aquí podrá solicitar y gestionar la investigación de una o varias relaciones."
						/>
					<PageContent>
						<Wrapper>
							<Sidebar currentUser={currentUser} activeTab={ activeTab } onTabChange={ this.handleTabChange.bind(this) } categories={categories} />
							<Content>
								{/* { activeTab.startsWith('tab-monitoring-') && <TabMonitoringDetails key={activeTab} type={activeTab.substring(15)} currentUser={currentUser} /> } */}
								{ activeTab === 'tab-dashboard' && <DashboardPage currentUser={currentUser} handleTabChange={this.handleTabChangeDashboard.bind(this) } /> }
								{ activeTab === 'tab-solicitudes' && <SolicitudesPage currentUser={currentUser} /> }
								{ activeTab === 'tab-forms' && <FormManagerPage currentUser={currentUser} options={options} /> }
								{ activeTab === 'tab-reporting' && <ReportingPage currentUser = {currentUser}/> }
							</Content>
						</Wrapper>
					</PageContent>
				</Page>
				<PageBottomBar breadcrumbs={ breadcrumbs } />
			</div>
		)
	}
}
export default withRouter(withTranslation()(CdiRelaciones))
